module.exports = __webpack_public_path__ + "static/media/login-background.cc2ccb0b.png";